/**
 * Define values to check if the token expires within given seconds
 */
export const TOKEN_MIN_VALIDITY_VALUES = {
  SKIP_CHECKING_EXPIRATION_DATE: -1,
  IF_ABOUT_TO_EXPIRE: 60,
} as const
